
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { SignupFormValues } from "../schemas/signupFormSchema";
import { ageRangeOptions } from "@/utils/selectOptions";

interface AgeRangeSelectorProps {
  form: UseFormReturn<SignupFormValues>;
}

export function AgeRangeSelector({ form }: AgeRangeSelectorProps) {
  return (
    <FormField
      control={form.control}
      name="ageRange"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Age Range</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value} 
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select your age range" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {ageRangeOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
